import { render, staticRenderFns } from "./unmaintainedDialog.vue?vue&type=template&id=bc3b3d54&scoped=true"
import script from "./unmaintainedDialog.vue?vue&type=script&lang=js"
export * from "./unmaintainedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3b3d54",
  null
  
)

export default component.exports